import React from 'react';
import { LocalFireDepartment, RestaurantMenu } from '@mui/icons-material';

export const TYPE_META = {
  calories: { label: 'Kalorien', icon: <RestaurantMenu fontSize="small" /> },
  streak:   { label: 'Streak',   icon: <LocalFireDepartment fontSize="small" /> },
};

export const BADGE_COLORS = {
  Bronze: '#cd7f32',
  Silber: '#9e9e9e',
  Gold:   '#c9a227',
  Platin: '#5b8def',
};

export const TIER_ORDER = ['Bronze', 'Silber', 'Gold', 'Platin'];
